/**
 * What must stay usable over any open window: the screen-share banner and
 * its code card. A modal window (Radix Dialog, Sheet, AlertDialog) turns off
 * pointer events on the page and closes on any click outside it; an element
 * marked with `data-over-dialogs` gets its pointer events back
 * (`pointer-events-auto`) and a click on it never closes the window.
 */
export const OVER_DIALOGS = 'data-over-dialogs'

function fromOverDialogs(event: Event): boolean {
  const original = (event as CustomEvent<{ originalEvent?: Event }>).detail?.originalEvent
  const target = (original?.target ?? event.target) as Element | null
  return Boolean(target && typeof target.closest === 'function' && target.closest(`[${OVER_DIALOGS}]`))
}

/** Wraps a window's outside-interaction handler: a click from the banner does not close it. */
export function keepOpenForOverDialogs<E extends Event>(handler?: (event: E) => void) {
  return (event: E) => {
    handler?.(event)
    if (fromOverDialogs(event)) event.preventDefault()
  }
}
